import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { SEARCH_FIELD_BOX_PADDING } from '../../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  exercisesListSearch: {
    marginTop: SEARCH_FIELD_BOX_PADDING,
  },
}));
